import WrapPageElement from './src/components/WrapPageElement'

export const wrapPageElement = WrapPageElement
